// extracted by mini-css-extract-plugin
module.exports = {"table-navigator-button":"style_table-navigator-button__2e0B9"};